const yodaSiteComponents = {
    GoogleAutoSuggestAddress: {
        importFn: () => import('yodaSiteComponents/GoogleAutoSuggestAddress'),
        path: 'yodaSiteComponents/GoogleAutoSuggestAddress',
        type: 'class',
        isSSR: false,
    },
};

module.exports = { yodaSiteComponents };
